import { BaseRich } from '../BaseRich';

class RichAngleBarDraw extends BaseRich {

}

export {
  RichAngleBarDraw,
};
